import React, { useEffect, useState } from "react";
import { CardContent, Grid, Typography } from "@material-ui/core";
import { Bar, defaults } from "react-chartjs-2";
import moment from "moment";
import { usageService } from "../../../services/usage.service";
import { store } from "../../../helpers";
import { appStyles } from "../../app/app-style";
import { appService } from "../../../services/app.service";
import { useMediaQuery } from "react-responsive";
import WeekCompareGraph from "./view/_weekly_usage_component";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { calPowerValuesService } from "../e_cal_power_values/model/service";
import ChartTest from "../e_energy_consumption/e_view/_e_bar-and-line-chart";
import PFMDGraph from "../e_energy_consumption/e_view/_pf_maxdemand_chart";

const customizedStyling = makeStyles((theme) => ({
  weeklyUsageTitleStyling: {
    marginLeft: "14px",
    marginTop: "8px",
    color: appStyles.outerTheme.palette.ePrimary?.base,
  },
  weeklyUsageTitleStylingNoData: {
    marginLeft: "14px",
    marginTop: "14px",
    color: appStyles.outerTheme.palette.ePrimary?.base
  },
   noDataStyling: {
    color: appStyles.outerTheme.palette.ePrimary?.base,
    fontWeight: "bold"
  },
  mainContainer: {
    marginTop: "10px",
  },
}));

const E_UsageComparison = () => {
  let classes = customizedStyling();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 768px)" });
  const isTabletOrMobileIpad = useMediaQuery({ query: "(min-width: 1024px)" });
  const isTabletOrMobileIpadMax = useMediaQuery({query: "(min-width: 1366px)", });
  let selectedCustomerNumber = localStorage.getItem("accountSelected")
  let width = "";
  let TabletOrMobileHeight = "";
  let legendLabelFont = 10;
  let isMobile = true;


  if (
    isTabletOrMobile === true &&
    isTabletOrMobileIpadMax === true &&
    isTabletOrMobileIpad === true
  ) {
    TabletOrMobileHeight = "335px";
    legendLabelFont = 14;
    isMobile = false;
    width = "85%";
  } else if (
    isTabletOrMobile === false &&
    isTabletOrMobileIpadMax === true &&
    isTabletOrMobileIpad === false
  ) {
    width = "100%";
    TabletOrMobileHeight = "335px";
    legendLabelFont = 8;
    isMobile = true;
  } else if (
    isTabletOrMobile === true &&
    isTabletOrMobileIpadMax === true &&
    isTabletOrMobileIpad === false
  ) {
    width = "100%";
    TabletOrMobileHeight = "335px";
    legendLabelFont = 8;
    isMobile = true;
  } else if (
    isTabletOrMobile === true &&
    isTabletOrMobileIpadMax === false &&
    isTabletOrMobileIpad === false
  ) {
    width = "50%";
    TabletOrMobileHeight = "335px";
    legendLabelFont = 8;
    isMobile = true;
  }
  else {
    width = "100%";
    TabletOrMobileHeight = "335px";
    legendLabelFont = 8;
    isMobile = true;

  }


  let units = "";
  
  const {t:weeklyUsageLabels, ready: weeklyUsageLabelReady } = useTranslation("label-E_WEEKLY_USAGE");

  units = weeklyUsageLabelReady ?  weeklyUsageLabels("E_WEEKLY_USAGE_UNITS") : '';
  const saId = store?.getState()?.meterDetails?.getSaInfo?.saId
  const accountId = store?.getState().meterDetails.accountId;
  const [noData, setNoData] = useState(false)
  const [graphData, setGraphData] = useState({
    currentBackground: appStyles?.outerTheme?.palette?.grayColor?.main,
    current: appStyles?.outerTheme?.palette?.blackColor?.main,
    lastBackground: appStyles?.outerTheme?.palette?.lightGrayColor?.main,
    usageData: { datasets: [], labels: [] },
    currentWeekUsage: "",
    lastWeekUsage: "",
    graphWidth: width,
    graphHeight: TabletOrMobileHeight,
    noData: false,
    legendLabelFont: 10,
    isMobile: isMobile
  })
  const [startDate,setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [endDate,setEndDate] = useState(moment(new Date()).subtract(1,"years").format("YYYY-MM-DD"))
  const [pfvalues,setPFvalue] = useState([])
  const [maxDvalues,setmaxDvalues] = useState([])
  const [formattedArr,setFormattedArr] = useState([])
  // useEffect(() => {
  //   const dates = {
  //     from_date: null,
  //     to_date: null,
  //   };
  //   dates.from_date = moment()
  //     .subtract(1, "weeks")
  //     .startOf("isoWeek")
  //     .format("YYYY-MM-DD");
  //   dates.to_date = moment()
  //     .endOf("isoWeek")
  //     .format("YYYY-MM-DD");
  //   (saId && accountId && dates) && usageService.usageWeekGraph(dates, saId, accountId,selectedCustomerNumber)
  //     .then((response) => {
  //       if (response) {
  //         let currentUsage = 0;
  //         let lastUsage = 0;
  //         let res = response?.data?.getUsageWeek;
  //         let filteredData = res?.usage[1]?.usage?.filter((item) => item !== 0);
  //         let currentFilteredData = res?.usage[0]?.usage?.filter((currentItem) => currentItem !== 0);
  //         if (filteredData?.length === 0 && currentFilteredData?.length === 0) {
  //           setNoData(true)
  //         }
  //         else {
  //           setNoData(false)
  //         }
  //         res.usage[1].usage.forEach((e) => {
  //           currentUsage = currentUsage + e;
  //         });
  //         res.usage[0].usage.forEach((e) => {
  //           lastUsage = lastUsage + e;
  //         });
  //         let usageData = {
  //           labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  //           datasets: [
  //             {
  //               fill: true,
  //               backgroundColor: appStyles?.outerTheme?.palette?.ePrimary?.base,
  //               borderColor: appStyles?.outerTheme?.palette?.ePrimary?.base,
  //               data: [...res?.usage[0]?.usage],
  //               barPercentage: 0.4,
  //               categoryPercentage: 0.5,
  //               borderRadius: {
  //                 topLeft: 100,
  //                 topRight: 100
  //               },
  //             },
  //             {
  //               fill: true,
  //               backgroundColor: appStyles?.outerTheme?.palette?.eSecondary?.base,
  //               borderColor: appStyles?.outerTheme?.palette?.eSecondary?.base,
  //               barPercentage: 0.4,
  //               categoryPercentage: 0.5,
  //               data: [...res?.usage[1]?.usage],
  //               borderRadius: {
  //                 topLeft: 100,
  //                 topRight: 100
  //               }
  //             }
  //           ]
  //         }
  //         setGraphData({
  //           usageData: usageData,
  //           lastWeekUsage: res?.usage[0]?.intervalName,
  //           currentWeekUsage: res?.usage[1]?.intervalName,
  //         })
  //       }
  //     })
  //   .catch(error => {
  //     setNoData(true)
  //     setGraphData()
  //   })
  //   return () => {

  //   }

  // }, [accountId])
  let labels={};
  const {t:accSummarylabels, ready: accountSummaryLabelReady} = useTranslation("label-ACCOUNT_SUMMARY");
  const {t:nodataLabel, ready: noDataLabelReady} = useTranslation("label-CONFIGURATIONS");
  if (accountSummaryLabelReady) {
    labels = {
      ACCOUNT_SUMMARY_USAGE_TITLE_GRAPH:
        accSummarylabels("ACCOUNT_SUMMARY_USAGE_TITLE_GRAPH"),
      MONTHLY_USAGE_SUB_TEXT: accSummarylabels("MONTHLY_USAGE_SUB_TEXT"),
      ACCOUNT_SUMMARY_USAGE_CURRENTWEEK:
        accSummarylabels("ACCOUNT_SUMMARY_USAGE_CURRENTWEEK"),
      ACCOUNT_SUMMARY_USAGE_LASTWEEK: accSummarylabels("ACCOUNT_SUMMARY_USAGE_LASTWEEK"),
      ACCOUNT_SUMMARY_VIEWALLCONSUMPTION:
        accSummarylabels("ACCOUNT_SUMMARY_VIEWALLCONSUMPTION"),
      nodataLabel: nodataLabel("NO_DATA_FOUND"),
    };
  }
  const getLegendLabel = (chartData, labels, mobileView) => {
    // Add the legend string to the dataset.
    if (chartData?.datasets && chartData?.datasets?.length === 2) {
      if(accountSummaryLabelReady) {
      if (mobileView) {
        chartData.datasets[0].label = `${accSummarylabels("Previous Week")}`
        chartData.datasets[1].label = `${accSummarylabels("ACCOUNT_SUMMARY_USAGE_CURRENTWEEK")}`
      } else {
        // Sum up the usage of the previous and current week.
        let lastWeekKwh = chartData?.datasets[0]?.data.reduce((a, b) => a + b, 0)
        let thisWeekKwh = chartData?.datasets[1]?.data.reduce((a, b) => a + b, 0)
        // Set the legend string.
        chartData.datasets[0].label = `${accSummarylabels("Previous Week")} (${graphData.lastWeekUsage}) - Total ${parseFloat(lastWeekKwh).toFixed(3)} kWh `
        chartData.datasets[1].label = `${accSummarylabels("ACCOUNT_SUMMARY_USAGE_CURRENTWEEK")} (${graphData.currentWeekUsage}) - Total ${parseFloat(thisWeekKwh).toFixed(3)} kWh`
      }
      }
    }
    return chartData
  }
  let chartData = [];
  if (graphData) {
    chartData = getLegendLabel(graphData?.usageData, labels, graphData?.isMobile);
  }



  let formatArray = (data)=>{
    if(!Array.isArray(data)){
      return []
    }
    let reversedArray =data;//reversing the array to main ascending order
    reversedArray=[...reversedArray].reverse();
    reversedArray=reversedArray.map(e=>{
      let formattedDate= moment(e?.msrmtDateTime,"YYYY-MM-DD-HH.mm.ss").format("MMM YY")
      if(e['powerFactor']){
        return {msrmtDateTime:formattedDate,powerFactor:e['powerFactor']}
      }
      else{
        return {msrmtDateTime:formattedDate,maxDemand:e['maxDemand']}
      }
    })
    return reversedArray;
  }

  let getLabels=(pfvalues,mdValues)=>{
      let label = [...pfvalues.map(e=>e['msrmtDateTime']),...mdValues.map(e=>e['msrmtDateTime'])]
      let noDuplicates = [...new Set(label)];
      let dates = noDuplicates
      let momentDates = dates.map(date => moment(date, "MMM y"));
      let sortedMomentDates = momentDates.sort((a, b) => a.valueOf() - b.valueOf());
      let sortedDatesString = sortedMomentDates.map(date => date.format("MMM y"));
      return sortedDatesString;
  }

  let formatValuesForLabels=(label,pfValues,mdValues)=>{
      let resultArray=[]
      pfValues.map(e=>{
        if(label.includes(e['msrmtDateTime'])){
          
          resultArray.push({msrmtDateTime:e['msrmtDateTime'],powerFactor:e['powerFactor'],maxDemand:0})
        }else{
          resultArray.push({msrmtDateTime:e['msrmtDateTime'],powerFactor:0,maxDemand:0})
        }
      })
      mdValues.map(e=>{
        const index = resultArray.findIndex(obj => obj.msrmtDateTime === e['msrmtDateTime']);
          if (index !== -1) {
            resultArray[index].maxDemand = e['maxDemand'];
          } else {
            resultArray.push({msrmtDateTime:e['msrmtDateTime'],powerFactor:0,maxDemand:e['maxDemand']})
          }
      })
     resultArray.sort((a, b) => {
      const dateA = moment(a.msrmtDateTime, 'MMM y');
      const dateB = moment(b.msrmtDateTime, 'MMM y');
    
      if (dateA.isBefore(dateB)) {
        return -1;
      } else if (dateA.isAfter(dateB)) {
        return 1;
      } else {
        return 0;
      }
    });
    return resultArray
  }

  useEffect(()=>{
    if(selectedCustomerNumber!=undefined && startDate!=undefined && endDate!=undefined){
      setFormattedArr([])
      calPowerValuesService.calPowerValues(selectedCustomerNumber,endDate,startDate)
      .then((response) =>{
        let pfValues=response?.data?.getMonthlyCalPowerValues?.powerFactor
        let mdValues=response?.data?.getMonthlyCalPowerValues?.maxDemand
        if(pfValues?.length==0 && mdValues?.length==0){
            setNoData(true)
        }else{
          setNoData(false)
          pfValues =formatArray(pfValues);
          mdValues=formatArray(mdValues)
          let labels =getLabels(pfValues,mdValues);
          let formatAllValues=formatValuesForLabels(labels,pfValues,mdValues)
          setPFvalue(pfValues)
          setmaxDvalues(mdValues)
          setFormattedArr(formatAllValues)
        }
      }).catch(e=>{
        setNoData(true)
      })
      
    }
  },[accountId])


  return (
    <>
      <Grid container direction="column" className={!noData && classes?.mainContainer}>

      <Grid item className={!noData? classes?.weeklyUsageTitleStyling :classes?.weeklyUsageTitleStylingNoData}>
      {
        weeklyUsageLabelReady ?
         <Typography variant="h6" className={classes?.titleStyling}><b>{weeklyUsageLabels("E_PFMD_HEADING")}</b></Typography> 
         : <Skeleton />
      }
        {/* </Grid>
        {noData ? null : (<><br /></>)}
        <Grid item > */}
        {/* <WeekCompareGraph  width={width} data={chartData} height={TabletOrMobileHeight} noData={noData} isMobile={isMobile} units={units}/> */}
        </Grid>
       {  <Grid item>
        <PFMDGraph noData={noData} values={formattedArr} width={width} maxDemand={maxDvalues} pfvalues={pfvalues} height={TabletOrMobileHeight} isMobile={isMobile} units={units}/>
        </Grid>}
      </Grid>
      {maxDvalues.length<1 && pfvalues.length<1 && (<Grid container direction="row" justify="center" alignItems="center" alignContent="center" >
        <Grid item >
        {
          weeklyUsageLabelReady ?
          <Typography variant="subtitle1" className={classes?.noDataStyling}>{weeklyUsageLabels("E_WEEKLY_USAGE_NO_DATA_TITLE")}</Typography>
          : <Skeleton />
        }
        </Grid>
      </Grid>)
      }
      
    </>
  )
}
export default E_UsageComparison